// Compiled at 2026-09-18T12:45:23.821Z
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty, jsonArrayProperty, AnyType } from "@sumbricht/json-class-serializer";
import { BoInfoSymbol } from "@lg/shared/for-apps";
import { computed, isSignal } from "../../signals.js";
import { Signals, HasSignalProperties } from "@lg/shared/for-apps";
import { equal } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { untracked } from "@angular/core";
@jsonClass('Orders.CustomerRequestItemMaterial')
class Orders__CustomerRequestItemMaterial {
    @jsonProperty(() => Orders__CustomerRequestItemMaterial.Id)
    id: Orders__CustomerRequestItemMaterial.Id;
    static readonly [BoInfoSymbol] = Object.freeze({
        boType: "Entity" as const,
        idType: "number" as const,
        editablePropertyNames: unwrapReadonly(Object.freeze(["id", "name", "materialAsMentionedInDrawing", "whereMaterialWasMentioned", "item", "itemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        computedPropertyNames: unwrapReadonly(Object.freeze([] as const)),
        allPropertyNames: unwrapReadonly(Object.freeze(["id", "name", "materialAsMentionedInDrawing", "whereMaterialWasMentioned", "item", "itemId", "createdOn", "createdBy", "updatedOn", "updatedBy", "deletedOn", "deletedBy", "versionNumber"] as const)),
        propertyNamesOfInterest: unwrapReadonly(Object.freeze(["id", "name", "materialAsMentionedInDrawing", "whereMaterialWasMentioned", "item", "itemId", "createdOn", "updatedOn", "deletedOn", "versionNumber"] as const)),
        propertyTypes: unwrapReadonly(Object.freeze({ "name": "string", "materialAsMentionedInDrawing": "string", "whereMaterialWasMentioned": "string", "item": "Orders.CustomerRequestItem", "itemId": "Orders.CustomerRequestItem.Id", "createdOn": "Date", "createdBy": "System.UserIdAndName", "updatedOn": "Date", "updatedBy": "System.UserIdAndName", "deletedOn": "Date", "deletedBy": "System.UserIdAndName", "versionNumber": "number", "id": "number" } as const)),
        staticEntityProperties: unwrapReadonly(Object.freeze([] as const)),
        searchInProperties: unwrapReadonly(Object.freeze(["id"] as const)),
        subsetNames: unwrapReadonly(Object.freeze([] as const)),
        manyToOneRelationships: unwrapReadonly(Object.freeze({ item: () => Orders.CustomerRequestItem } as const)),
        oneToManyRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneOwningRelationships: unwrapReadonly(Object.freeze({} as const)),
        oneToOneSecondaryRelationships: unwrapReadonly(Object.freeze({} as const)),
        embeddedEntities: unwrapReadonly(Object.freeze({} as const)),
        get allRelationships() {
            return {
                ...this.manyToOneRelationships,
                ...this.oneToManyRelationships,
                ...this.oneToOneOwningRelationships,
                ...this.oneToOneSecondaryRelationships,
            } as const
        },
    });
    static readonly Id = Number;
    readonly [HasSignalProperties] = true;
    [immerable] = true;
    private readonly θname = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θmaterialAsMentionedInDrawing = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θwhereMaterialWasMentioned = Signals.proxySignalDeferred<string>(() => (undefined) as any);
    private readonly θitem = Signals.proxySignalDeferred<Orders.CustomerRequestItem>(() => (undefined) as any);
    private readonly θitemId = Signals.proxySignalDeferred<Orders.CustomerRequestItem.Id>(() => (undefined) as any);
    private readonly θcreatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θcreatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θupdatedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θupdatedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θdeletedOn = Signals.proxySignalDeferred<Date>(() => (undefined) as any);
    private readonly θdeletedBy? = Signals.proxySignalDeferred<System.UserIdAndName>(() => (undefined) as any);
    private readonly θversionNumber = Signals.proxySignalDeferred<number>(() => (undefined) as any);

    static get __type(): 'Orders.CustomerRequestItemMaterial' {
        return 'Orders.CustomerRequestItemMaterial'
    }

    set __type(_) {
    }

    @jsonProperty(String)
    get __type(): 'Orders.CustomerRequestItemMaterial' {
        return 'Orders.CustomerRequestItemMaterial'
    }

    static get __baseType(): 'Orders.CustomerRequestItemMaterial' {
        return 'Orders.CustomerRequestItemMaterial'
    }

    set __baseType(_) {
    }

    get __baseType(): 'Orders.CustomerRequestItemMaterial' {
        return 'Orders.CustomerRequestItemMaterial'
    }

    get [BoInfoSymbol]() {
        return Orders__CustomerRequestItemMaterial[BoInfoSymbol]
    }

    get name(): string {
        return this.θname?.()
    }

    set name(name) {
        this.θname.set(coerceDataType(name, 'string', false, true))
    }

    get materialAsMentionedInDrawing(): string {
        return this.θmaterialAsMentionedInDrawing?.()
    }

    set materialAsMentionedInDrawing(materialAsMentionedInDrawing) {
        this.θmaterialAsMentionedInDrawing.set(coerceDataType(materialAsMentionedInDrawing, 'string', false, true))
    }

    get whereMaterialWasMentioned(): string {
        return this.θwhereMaterialWasMentioned?.()
    }

    set whereMaterialWasMentioned(whereMaterialWasMentioned) {
        this.θwhereMaterialWasMentioned.set(coerceDataType(whereMaterialWasMentioned, 'string', false, true))
    }

    get item(): Orders.CustomerRequestItem {
        return this.θitem?.()
    }

    set item(item) {
        this.θitem.set(coerceDataType(item, Orders.CustomerRequestItem, false, true))
        if (item) {
            this.θitemId.set(item.id)
        } else if (item === null && item) {
            this.θitemId.set(null)
        }
    }

    get itemId(): Orders.CustomerRequestItem.Id {
        return this.θitemId?.()
    }

    set itemId(itemId) {
        if (itemId === null) this.θitem.set(null)
        if (this.item?.id && itemId != this.item.id) throw new Error('Cannot set entity id to a different value than the current entity id')
        this.θitemId.set(coerceDataType(itemId, 'Orders.CustomerRequestItem.Id', false, true))
    }

    get createdOn(): Date {
        return this.θcreatedOn?.()
    }

    set createdOn(createdOn) {
        this.θcreatedOn.set(coerceDataType(createdOn, 'Date', false, true))
    }

    get createdBy(): System.UserIdAndName {
        return this.θcreatedBy?.()
    }

    set createdBy(createdBy) {
        this.θcreatedBy.set(coerceDataType(createdBy, 'System.UserIdAndName', false, true))
    }

    get updatedOn(): Date {
        return this.θupdatedOn?.()
    }

    set updatedOn(updatedOn) {
        this.θupdatedOn.set(coerceDataType(updatedOn, 'Date', false, true))
    }

    get updatedBy(): System.UserIdAndName {
        return this.θupdatedBy?.()
    }

    set updatedBy(updatedBy) {
        this.θupdatedBy.set(coerceDataType(updatedBy, 'System.UserIdAndName', false, true))
    }

    get deletedOn(): Date {
        return this.θdeletedOn?.()
    }

    set deletedOn(deletedOn) {
        this.θdeletedOn.set(coerceDataType(deletedOn, 'Date', false, true))
    }

    get deletedBy(): System.UserIdAndName {
        return this.θdeletedBy?.()
    }

    set deletedBy(deletedBy) {
        this.θdeletedBy.set(coerceDataType(deletedBy, 'System.UserIdAndName', false, true))
    }

    get versionNumber(): number {
        return this.θversionNumber?.()
    }

    set versionNumber(versionNumber) {
        this.θversionNumber.set(coerceDataType(versionNumber, 'number', false, true))
    }

    constructor(init?: Partial<Orders__CustomerRequestItemMaterial>, initOneToManyRelations = false) {
        if (initOneToManyRelations) {
            init = {
                ...init
            }

        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(this)))) {
            if (pd.get) Object.defineProperty(this, p, { ...pd, enumerable: true })
        }

        for (const [p, pd] of Object.entries(Object.getOwnPropertyDescriptors(this))) {
            if (p.startsWith('θ')) Object.defineProperty(this, p, { ...pd, enumerable: false })
        }

        untracked(() => assignCommonProperties(this, init))
        const θinitFn: any = (this as any).init
        if (typeof θinitFn == 'function') θinitFn(init)
    }

    θtoPlainObject(recursive = true, includeType = false) {
        const obj = {}

        for (const key of this.θgetPropertyNames(includeType)) {
            let value = Reflect.get(this, key) as any
            if (recursive && typeof value?.θtoPlainObject == 'function') {
                value = value.θtoPlainObject(recursive, includeType)
            }

            Reflect.set(obj, key, value)
        }

        return obj
    }

    $clone(deep: boolean = true, θcloneMap = new Map<any, any>()) {
        if (θcloneMap.has(this)) return θcloneMap.get(this)
        const clone = new Orders__CustomerRequestItemMaterial()
        θcloneMap.set(this, clone)
        function cloneValue(value: any) {
            if (θcloneMap.has(value)) return θcloneMap.get(value)
            if (typeof value?.$clone == "function") {
                return value.$clone(deep, θcloneMap)
            } else if (Array.isArray(value)) {
                return value.map(cloneValue)
            } else if (isSignal(value)) {
                return Signals.proxySignalDeferred(() => cloneValue(value()))
            }

            return value
        }

        if (deep) {
            for (const [key, value] of Object.entries(this)) {
                Reflect.set(clone, key, cloneValue(value))
            }

        }

        return clone
    }

    $updateFrom(source: Partial<Orders__CustomerRequestItemMaterial>, restrictToClass?: Class<Partial<Orders__CustomerRequestItemMaterial>>) {
        assignCommonProperties(this, source, { restrictToClass })
    }

    θgetPropertyNames(includeType: boolean = false) {
        const names: string[] = []
        names.push('id')
        names.push('name', 'materialAsMentionedInDrawing', 'whereMaterialWasMentioned', 'item', 'itemId', 'createdOn', 'createdBy', 'updatedOn', 'updatedBy', 'deletedOn', 'deletedBy', 'versionNumber')
        if (includeType) names.push('__type')
        return names
    }

    θcleanupBeforeSave() {
    }

    $equals(other: any): other is Orders__CustomerRequestItemMaterial {
        return equal(this, other)
    }
}

namespace Orders__CustomerRequestItemMaterial { }

export import CustomerRequestItemMaterial = Orders__CustomerRequestItemMaterial
setTimeout(() => {
    jsonProperty(() => String)(Orders__CustomerRequestItemMaterial.prototype, 'name')
    jsonProperty(() => String)(Orders__CustomerRequestItemMaterial.prototype, 'materialAsMentionedInDrawing')
    jsonProperty(() => String)(Orders__CustomerRequestItemMaterial.prototype, 'whereMaterialWasMentioned')
    jsonProperty(() => Orders.CustomerRequestItem)(Orders__CustomerRequestItemMaterial.prototype, 'item')
    jsonProperty(() => Orders.CustomerRequestItem.Id)(Orders__CustomerRequestItemMaterial.prototype, 'itemId')
    jsonProperty(() => Date)(Orders__CustomerRequestItemMaterial.prototype, 'createdOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestItemMaterial.prototype, 'createdBy')
    jsonProperty(() => Date)(Orders__CustomerRequestItemMaterial.prototype, 'updatedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestItemMaterial.prototype, 'updatedBy')
    jsonProperty(() => Date)(Orders__CustomerRequestItemMaterial.prototype, 'deletedOn')
    jsonProperty(() => System.UserIdAndName)(Orders__CustomerRequestItemMaterial.prototype, 'deletedBy')
    jsonProperty(() => Number)(Orders__CustomerRequestItemMaterial.prototype, 'versionNumber')
})

export const CustomerRequestItemMaterialθId = Number;

export type CustomerRequestItemMaterialθId = number;

namespace Orders__CustomerRequestItemMaterial {
    export type Id = NominalType<number, 'Orders.CustomerRequestItemMaterial'>

}
